import { render, staticRenderFns } from "./KETWidgetTrainer.vue?vue&type=template&id=da062ace&"
import script from "./KETWidgetTrainer.vue?vue&type=script&lang=js&"
export * from "./KETWidgetTrainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports